import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  total: 'Total',
  gstPrice: 'Includes AU{dollarSign}{gst} GST',
  totalPrice: 'AU{dollarSign}{total}',
})
